/* eslint-disable prettier/prettier */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendEmailVerification } from "firebase/auth";
import { useAuth } from "../contexts/AuthContext";

const VerifyEmailPage = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleResend = async () => {
    if (!currentUser) return;
    setLoading(true);
    try {
      await sendEmailVerification(currentUser);
      setMessage("Verification email sent. Please check your inbox.");
    } catch (err) {
      console.error("Error sending verification email", err);
      setMessage("Failed to send verification email. Please try again later.");
    }
    setLoading(false);
  };

  const handleRefreshStatus = async () => {
    if (!currentUser) return;
    setLoading(true);
    await currentUser.reload();
    if (currentUser.emailVerified) {
      navigate("/create-profile", { replace: true });
    } else {
      setMessage(
        "Email still not verified. Please check your inbox or spam folder.",
      );
    }
    setLoading(false);
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-4 bg-cover bg-center"
      style={{ backgroundImage: "url('/background-mila-care.png')" }}
    >
      <div className="w-full max-w-md bg-white/90 rounded-xl shadow-2xl p-8 space-y-6 backdrop-blur-sm text-center">
        <h1 className="text-3xl font-bold text-blue-600">Verify Your Email</h1>
        <p className="text-gray-700">
          We have sent a verification link to{" "}
          <span className="font-semibold">{currentUser?.email}</span>.<br />
          Please click the link in that email to activate your account.
        </p>

        {message && (
          <div className="p-3 bg-blue-50 border border-blue-200 rounded-md text-sm text-blue-700">
            {message}
          </div>
        )}

        <button
          onClick={handleResend}
          disabled={loading}
          className="w-full py-3 px-4 rounded-md text-white bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 disabled:opacity-70"
        >
          {loading ? "Sending..." : "Resend Verification Email"}
        </button>

        <button
          onClick={handleRefreshStatus}
          disabled={loading}
          className="w-full py-3 px-4 mt-2 rounded-md text-blue-600 border border-blue-600 hover:bg-blue-50 disabled:opacity-70"
        >
          {loading ? "Checking..." : "I've Verified My Email"}
        </button>
      </div>
    </div>
  );
};

export default VerifyEmailPage; 